export const ADMIN = 'admin'
export const EDITOR = 'editor'
export const AGENT = 'agent'

export const USER_ROLES = {
  [ADMIN]: 'Admin',
  [EDITOR]: 'Editor',
  [AGENT]: 'Agent'
}
